<footer class="footer" [ngClass]="[getBrandClassName(), hasOfferBar ? 'has-offer' : '']">
  @if (isWindowNationBrand) {
    <div class="section">
      <div class="container">
        <div class="footer-top">
          <a
            [href]="brandConfig.headerOverrides.homeUrl"
            class="footer-logo-link"
            target="_blank"
            ><span
            ><span
            ><figure>
            <img
              [src]="brandConfig.logoPath"
              [alt]="brandConfig.logoAlt"
              style="object-fit: contain; object-position: left center"
            /></figure></span></span
          ></a>
          <ul>
            @for (icon of FOOTER_MAP.socialIcons; track icon) {
              <li>
                <a
                  [href]="icon.socialMediaLink.href"
                  [title]="icon.socialMediaLink.title"
                  target="_blank"
                  class="footer-social-link"
                  ><span class="control-group"
                  ><span [innerHtml]="icons[icon.icon]"></span></span
                ></a>
              </li>
            }
          </ul>
        </div>
        <div
          class="grid footer-content"
          style="grid-template-columns: repeat(12, 1fr)"
          >
        @for (column of footerMap.linkLists; track column) {
          <div
            class="column"
            style="--col-md-span: 6; --col-lg-span: 3"
            >
            <h2 class="title">{{column.header}}</h2>
            <ul>
              @for (item of column.item; track item) {
                <li>
                  <a
                    tabindex="0"
                    [href]="modifyUrl(item.href)"
                    target="_blank"
                    class=""
                    ><span class=""
                    ><span>{{item.title}}</span></span
                    ></a
                    >
                  </li>
                }
              </ul>
            </div>
          }
        </div>
        <div class="footer-bottom">
          <p>{{footerMap.subfooter.subfooterText}}</p>
          <div class="footer-policies">
            <p>{{footerMap.subfooter.copyrightLanguage}}</p>
            <ul>
              @for (item of footerMap.subfooter.policies.policyLink; track item) {
                <li>
                  <a
                    tabindex="0"
                    target="_blank"
                    [href]="modifyUrl(item.href)"
                    ><span
                    ><span>{{item.title}}</span></span
                    ></a
                    >
                  </li>
                }
              </ul>
            </div>
          </div>
        </div>
      </div>
  }

  @if (isNewsouthBrand) {
    <div class="newsouth-footer-wrap container">
      <div class="newsouth-head">
        <div class="newsouth-logo-block">
          <img [src]="brandConfig.logoPath" [alt]="brandConfig.logoAlt" />
        </div>
        <div class="newsouth-head-socials">
          <a [href]="newsouthSocialLinks[0].href" target="_blank" title="YouTube" [innerHtml]="icons['Youtube']"></a>
          <a [href]="newsouthSocialLinks[1].href" target="_blank" title="Facebook" [innerHtml]="icons['Facebook']"></a>
          <a [href]="newsouthSocialLinks[2].href" target="_blank" title="LinkedIn" [innerHtml]="icons['Linkedin']"></a>
          <a [href]="newsouthSocialLinks[3].href" target="_blank" title="X" [innerHtml]="icons['X']"></a>
        </div>
      </div>

      <div class="newsouth-grid">
        @for (section of newsouthSections; track section.title) {
          <div class="newsouth-section">
            <h3>
              @if (section.href) {
                <a [href]="section.href" target="_blank">{{section.title}}</a>
              } @else {
                {{section.title}}
              }
            </h3>
            <ul>
              @for (item of section.links; track item.title) {
                <li>
                  <a [href]="modifyUrl(item.href)" target="_blank">{{item.title}}</a>
                </li>
              }
            </ul>
          </div>
        }
      </div>

      <div class="newsouth-bottom">
        <p>{{newsouthCopyright}}</p>
        <p>{{newsouthLicenseText}}</p>
      </div>
    </div>
  }

  @if (isArmorvueBrand) {
    <div class="armorvue-footer-wrap container">
      <div class="armorvue-top">
        <div class="armorvue-logo-block">
          <img src="https://armorvue.com/wp-content/uploads/2024/11/PBWN_ArmorvueColor_Logo_.webp" alt="Armorvue Powered by Window Nation" />
        </div>

        @for (section of armorvueSections; track section.title) {
          <div class="armorvue-section">
            <h3>{{section.title}}</h3>
            <ul>
              @for (item of section.links; track item.title) {
                <li>
                  <a [href]="modifyUrl(item.href)" target="_blank">{{item.title}}</a>
                </li>
              }
            </ul>
          </div>
        }

        <div class="armorvue-connect">
          <h3>Connect With Us</h3>
          <div class="armorvue-socials">
            <a [href]="armorvueSocialLinks[0].href" target="_blank" title="Facebook" [innerHtml]="icons['ArmorvueFacebook']"></a>
            <a [href]="armorvueSocialLinks[1].href" target="_blank" title="YouTube" [innerHtml]="icons['ArmorvueYoutube']"></a>
            <a [href]="armorvueSocialLinks[2].href" target="_blank" title="Instagram" [innerHtml]="icons['ArmorvueInstagram']"></a>
          </div>
        </div>
      </div>

      <div class="armorvue-policies">
        @for (item of armorvuePolicyLinks; track item.title; let i = $index) {
          <a [href]="modifyUrl(item.href)" target="_blank">{{item.title}}</a>
          @if (i < armorvuePolicyLinks.length - 1) {
            <span>|</span>
          }
        }
      </div>

      <div class="armorvue-bottom">
        <p>{{armorvueCopyright}}</p>
      </div>
    </div>
  }
</footer>
